module.exports = __webpack_public_path__ + "static/media/Avenir-Medium.28002881.woff2";